const optionsMessages = {
    'day': ['lunes'],
    'time': ['2pm'],
    'text': ['Ingresa el texto...'],
    'link': ['www.minegocio.com'],
    'percent': ['20%'],
    'date': ['22/06/2022']
}

export default optionsMessages;